import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v38.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import e from "@arcgis/core/Graphic";
import * as t from "@arcgis/core/geometry/geometryEngine";
import i from "@arcgis/core/geometry/Point";
import s from "@arcgis/core/geometry/Polygon";
import o from "@arcgis/core/widgets/Sketch/SketchViewModel";
import r from "@arcgis/core/geometry/SpatialReference";
import { B as a } from "../base-toolbar.js";
import { T as n, i as l } from "../index.js";
import { c as h, T as d, e as c, C as p } from "../enums.js";
import { L as m, A as u } from "../utils/auto-pan.js";
import { G as y } from "../geometry/creator.js";
import { G as g, b as _ } from "../geometry/utils.js";
import { S as f } from "../symbols.js";
import { M as v, L as w } from "../utils/map.js";
import { H as G } from "../history-manager.js";
import { L as b } from "../label-manager.js";
import { aw as L } from "../api/rec.js";
import "uuid";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import "lodash";

var DrawToolsOverlapManager = /*#__PURE__*/function () {
  function DrawToolsOverlapManager(e) {
    _classCallCheck(this, DrawToolsOverlapManager);

    this._importBoundaries = [], this._newPolygonEvent = null, this._editGeometryEvent = null, this._previousState = null, this._currentState = {
      customerBoundaries: [],
      boundaries: [],
      geometries: [],
      fieldBoundaryMap: {}
    }, this._options = e;
  }

  _createClass(DrawToolsOverlapManager, [{
    key: "canUndo",
    value: function canUndo() {
      return !!this._previousState;
    }
  }, {
    key: "checkGeometriesForOverlap",
    value: function checkGeometriesForOverlap(e) {
      return g.checkIntersections(e, this._currentState.customerBoundaries.map(function (e) {
        return e.shape;
      }), null);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.reset();
    }
  }, {
    key: "clipToOtherFields",
    value: function clipToOtherFields() {
      this._setCurrentState(_objectSpread({}, this._currentState), !1);
    }
  }, {
    key: "clipOtherFields",
    value: function clipOtherFields() {
      var e, i;

      var s = [].concat(_toConsumableArray(this._importBoundaries), [null === (e = this._newPolygonEvent) || void 0 === e ? void 0 : e.event.geometry, null === (i = this._editGeometryEvent) || void 0 === i ? void 0 : i.graphics[0].geometry]).filter(Boolean),
          o = this._currentState.customerBoundaries.filter(function (e) {
        return s.find(function (i) {
          return t.intersects(i, e.shape);
        });
      }),
          r = new Set([].concat(_toConsumableArray(o.map(function (e) {
        return e.fieldGuid;
      })), _toConsumableArray(this._currentState.boundaries.map(function (e) {
        return e.fieldGuid;
      })))),
          a = [],
          n = this._currentState.customerBoundaries.reduce(function (e, i) {
        if (!r.has(i.fieldGuid)) return a.push(i), e;
        e[i.fieldGuid] = e[i.fieldGuid] || [];
        var o = i.shape;

        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _r = _step.value;
            o = t.difference(o, _r);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var n = _objectSpread(_objectSpread({}, i), {}, {
          shape: o
        });

        return e[i.fieldGuid].push(n), a.push(n), e;
      }, {}),
          l = [].concat(_toConsumableArray(this._currentState.boundaries), _toConsumableArray(o)),
          h = [].concat(_toConsumableArray(this._currentState.geometries), _toConsumableArray(s));

      this._setCurrentState({
        customerBoundaries: a,
        boundaries: l,
        geometries: h,
        fieldBoundaryMap: n
      }, !1), this._fieldsLayer.setClippedFieldBoundaries(l.map(function (e) {
        return e.fieldBoundaryGuid;
      }), h), this._options.onClipOtherFields(n);
    }
  }, {
    key: "hasPendingEditGeometryEvent",
    value: function hasPendingEditGeometryEvent() {
      return !!this._editGeometryEvent;
    }
  }, {
    key: "hasPendingImportBoundaries",
    value: function hasPendingImportBoundaries() {
      return this._importBoundaries.length > 0;
    }
  }, {
    key: "hasPendingNewPolygonEvent",
    value: function hasPendingNewPolygonEvent() {
      return !!this._newPolygonEvent;
    }
  }, {
    key: "setCustomerBoundaries",
    value: function setCustomerBoundaries(e) {
      var t = e.filter(function (e) {
        return !!e.shape;
      }).map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          shape: e.shape.clone()
        });
      });
      this._currentState.customerBoundaries = t;
    }
  }, {
    key: "getClippedCustomerBoundariesCombined",
    value: function getClippedCustomerBoundariesCombined() {
      var _this = this;

      var e = this._currentState.customerBoundaries.filter(function (e) {
        return !!e.shape;
      }).map(function (e) {
        return _this._simplify(e.shape);
      }).filter(function (e) {
        return e;
      });

      return _.getClippingBoundaries(e, new r({
        wkid: L
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      this._importBoundaries = [], this._newPolygonEvent = null, this._editGeometryEvent = null, e && (this._options.onClipOtherFields({}), this._fieldsLayer.clearClippedFieldBoundaries(), this._previousState = null, this._currentState = {
        customerBoundaries: [],
        boundaries: [],
        geometries: [],
        fieldBoundaryMap: {}
      });
    }
  }, {
    key: "undo",
    value: function undo() {
      this._previousState && (this._setCurrentState(this._previousState, !0), this._fieldsLayer.setClippedFieldBoundaries(this._currentState.boundaries.map(function (e) {
        return e.fieldBoundaryGuid;
      }), this._currentState.geometries), this._options.onClipOtherFields(this._currentState.fieldBoundaryMap));
    }
  }, {
    key: "_setCurrentState",
    value: function _setCurrentState(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      this._previousState = t ? null : this._currentState, this._currentState = e;
    }
  }, {
    key: "_simplify",
    value: function _simplify(e) {
      return t.isSimple(e) ? e : t.simplify(e);
    }
  }, {
    key: "importBoundaries",
    get: function get() {
      return this._importBoundaries;
    },
    set: function set(e) {
      this.reset(), this._importBoundaries = e;
    }
  }, {
    key: "newPolygonEvent",
    get: function get() {
      return this._newPolygonEvent;
    },
    set: function set(e) {
      this.reset(), this._newPolygonEvent = e;
    }
  }, {
    key: "editGeometryEvent",
    get: function get() {
      return this._editGeometryEvent;
    },
    set: function set(e) {
      this.reset(), this._editGeometryEvent = e;
    }
  }, {
    key: "fieldsLayer",
    set: function set(e) {
      this._fieldsLayer = e;
    }
  }]);

  return DrawToolsOverlapManager;
}();

var P = 0,
    C = 1;

var DrawTools = /*#__PURE__*/function (_a) {
  _inherits(DrawTools, _a);

  var _super = _createSuper(DrawTools);

  function DrawTools(e, i) {
    var _this2;

    _classCallCheck(this, DrawTools);

    _this2 = _super.call(this, e, i), _this2.geometries = [], _this2.history = new G(), _this2.isEditing = !1, _this2.keyEvent = null, _this2.mapListeners = new m(), _this2.toolbarListeners = new m(), _this2.windowListeners = new m(), _this2.setFieldData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var i,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                i = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : !1;

                if (!(_this2.isImport = i && Boolean(e.importFieldBoundaryGuidList), _this2.importFieldBoundaryGuidList = e.importFieldBoundaryGuidList, _this2.fieldData = e, !_this2.isImport && !_this2.fieldsLayer)) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("Field layer undefined");

              case 3:
                if (!(_this2.isImport && !_this2.fieldBoundaryImportLayer)) {
                  _context2.next = 5;
                  break;
                }

                throw new Error("Field Boundary Import Layer undefined");

              case 5:
                _this2.options.onSetMapIsLoading(!0);

                _this2.options.onSetToolsProcessing(!0);

                _context2.next = 9;
                return _this2.clear().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var i, s, o;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          i = _this2.isImport ? function (e) {
                            return _this2.fieldBoundaryImportLayer.getImportFieldBoundaries(e).then(function (e) {
                              return e.map(function (e) {
                                return e.shape;
                              });
                            });
                          } : function (e) {
                            return _this2.fieldsLayer.getFieldBoundary(e).then(function (e) {
                              return e.map(function (e) {
                                return e.shape;
                              });
                            });
                          }, s = _this2.isImport ? e.importFieldBoundaryGuidList : e.fieldGuid;

                          if (!s) {
                            _context.next = 6;
                            break;
                          }

                          _context.next = 4;
                          return i(s).then(function (i) {
                            var s = null,
                                o = 0;

                            var r = _.getAllPolygonParts(i.map(_this2._simplify).filter(function (e) {
                              return e;
                            }));

                            if (r.length > 0) {
                              var _iterator2 = _createForOfIteratorHelper(r),
                                  _step2;

                              try {
                                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                                  var _e = _step2.value;

                                  var _t = _this2.calculateAbsRawArea(_e);

                                  (!s || _t > o) && (o = _t, s = _e);
                                }
                              } catch (err) {
                                _iterator2.e(err);
                              } finally {
                                _iterator2.f();
                              }

                              _this2.mapView.extent = t.union(r).extent.expand(v.defaults.extentExpandFactor), _this2._updateGeometries(r, !0), _this2._resetGraphics(), _this2._activateEditsForGeometry(s);
                            } else _this2.fieldsLayer.zoomToCustomer(e.customerGuid, !0);

                            _this2._createMapListeners(), _this2.options.onSetMapIsLoading(!1);
                          });

                        case 4:
                          _context.next = 7;
                          break;

                        case 6:
                          !_this2.isImport && _this2.mapView.scale > n.layers.fields.minScale && _this2.fieldsLayer.zoomToCustomer(e.customerGuid, !0), _this2._createMapListeners(), _this2.options.onSetMapIsLoading(!1);

                        case 7:
                          console.assert(null != e.customerGuid);
                          _this2.customerGuid = e.customerGuid;
                          o = [];
                          o.push(_this2._getCustomerFieldBoundary(e.customerGuid, e.fieldGuid, _this2.mapView.extent.expand(6))), _this2.isImport && o.push(_this2._getOtherImportFieldBoundaries()), Promise.all(o).then(function () {
                            _this2.options.onSetToolsProcessing(!1);
                          }), _this2._bubbleOpLayers();

                        case 11:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _this2.messages = _this2.options.messages, _this2.intlConfig = i.intlConfig, _this2.onOverlapDetected = i.onOverlapDetected, _this2.onUpdateGeometries = i.onUpdateGeometries, _this2.onSetCanClip = i.onSetCanClip, _this2.onSetCanClipPending = i.onSetCanClipPending, _this2.setEditClip = i.setEditImportEditClip, _this2.layer = _this2.getLayer("EDIT_FIELDS_LAYER"), _this2.measureLayer = _this2.getLayer("EDIT_FIELDS_MEASUREMENTS_LAYER"), _this2.geometrySymbol = f.fromJSON(n.symbols.draw.polygon.fill), _this2.invalidSymbol = f.fromJSON(n.symbols.draw.polygon.invalid), _this2.radiusLineSymbol = f.fromJSON(n.symbols.draw.measure.line);

    var geomCreatorOptions = function geomCreatorOptions(e) {
      return {
        drawLayer: _this2.layer,
        geometryType: e,
        invalidSymbol: _this2.invalidSymbol.clone(),
        onDraw: function onDraw(t) {
          return _this2._onDraw(e, t);
        },
        symbol: _this2.geometrySymbol.clone()
      };
    };

    _this2.circleCreator = new y(_this2.mapView, geomCreatorOptions(h.CIRCLE)), _this2.polygonCreator = new y(_this2.mapView, geomCreatorOptions(h.POLYGON)), _this2.polylineCreator = new y(_this2.mapView, {
      drawLayer: _this2.layer,
      geometryType: h.POLYLINE,
      onDraw: function onDraw(e) {
        return _this2._onDraw(h.POLYLINE, e);
      },
      symbol: f.fromJSON(n.symbols.draw.reshape.line)
    }), _this2.labelManager = new b(_this2.layer), _this2.measureLabelManager = new b(_this2.measureLayer), _this2.selectedSymbol = f.fromJSON(n.symbols.draw.nudge.fill), _this2.nudgeLabelManager = new b(_this2.layer, n.symbols.draw.nudge.label), _this2.nudgeDirectionsLabel = _this2.options.formatMessage(_this2.messages.nudgeDirections), _this2.editToolbar = new o({
      activeFillSymbol: f.fromJSON(n.symbols.draw.polygon.fill),
      view: _this2.mapView,
      layer: _this2.layer,
      defaultUpdateOptions: {
        enableZ: !1,
        multipleSelectionEnabled: !1,
        preserveAspectRatio: !0,
        reshapeOptions: {
          shapeOperation: "none"
        }
      },
      polygonSymbol: f.fromJSON(n.symbols.draw.polygon.fill),
      polylineSymbol: f.fromJSON(n.symbols.draw.measure.line),
      pointSymbol: f.fromJSON(n.symbols.draw.edit.vertex),
      updateOnGraphicClick: !1
    }), _this2._createEditToolbarListeners(), _this2.autoPan = new u(_this2.mapView), _this2.autoPan.setEditToolbar(_this2.editToolbar), _this2._overlapManager = new DrawToolsOverlapManager({
      onClipOtherFields: i.onClipOtherFields
    });
    return _this2;
  }

  _createClass(DrawTools, [{
    key: "_activateEditsForGeometry",
    value: function _activateEditsForGeometry(e) {
      var _this3 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (this.selectedGeometry = e ? new s(e.toJSON()) : null, this._updateAcreageLabel(e), this.nudgeLabelManager.clearLabel(), !e) return;

      this._canClip();

      var i = this._moveGeometryToTop(e);

      i && (!t && [d.DrawNudge, d.DrawUnion].includes(this.activeTool) ? (this.editToolbar.cancel(), i.set("symbol", this.selectedSymbol), this.activeTool === d.DrawNudge && this.editToolbar.update(i, {
        tool: "move"
      }).then(function () {
        _this3._updateAcreageLabel(e), _this3.nudgeLabelManager.updateLabel(e.extent.center, _this3.nudgeDirectionsLabel);
      })) : this.editToolbar.update(i, {
        tool: "reshape"
      }).then(function () {
        _this3._updateAcreageLabel(e);
      }), this.forceUpdate());
    }
  }, {
    key: "_applyHistoryState",
    value: function _applyHistoryState(e) {
      this.editToolbar.cancel(), this.geometries = e, this._resetGraphics(), this.onUpdateGeometries(this.geometries), this.onSetCanClip(this._canClip()), this.forceUpdate(), !this.history.canUndo() && this._overlapManager.canUndo() && this._undoOverlapSelection();
    }
  }, {
    key: "_undoOverlapSelection",
    value: function _undoOverlapSelection() {
      var _this4 = this;

      if (this._overlapManager.undo(), this.customerClipBoundary = this._overlapManager.getClippedCustomerBoundariesCombined(), this._overlapManager.hasPendingNewPolygonEvent() && this.lastDrawnPolygonPoints && this.polygonCreator.activate(this.lastDrawnPolygonPoints), this._overlapManager.hasPendingImportBoundaries) {
        var _t2 = this._overlapManager.importBoundaries.map(function (t) {
          return new e({
            attributes: {
              clippedGeometry: !0
            },
            geometry: t,
            symbol: _this4.geometrySymbol
          });
        });

        this.layer.addMany(_t2);
      }

      this.onOverlapDetected();
    }
  }, {
    key: "_areEqual",
    value: function _areEqual(e, t) {
      return !(!e || !t) && _.almostEqualPolygons(e, t);
    }
  }, {
    key: "_bubbleOpLayers",
    value: function _bubbleOpLayers() {
      this.moveLayersToTop([this.layer, this.measureLayer]);
    }
  }, {
    key: "_canClip",
    value: function _canClip() {
      var e = _toConsumableArray(this.geometries);

      return g.checkIntersections(e, [this.customerClipBoundary, this.otherImportsClipBoundary], this.selectedGeometry);
    }
  }, {
    key: "_clipPolygon",
    value: function _clipPolygon(e) {
      var _this5 = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : P;
      var s = arguments.length > 2 ? arguments[2] : undefined;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

      try {
        var _ref3 = this.keyEvent || {},
            _a2 = _ref3.altKey,
            _n = _ref3.ctrlKey,
            _l = _a2 || _n;

        switch (i) {
          case P:
            {
              var _i = this.geometries.length ? t.union(this.geometries) : null,
                  _s = _i && t.within(e, _i),
                  _a3 = _i && _l && t.intersects(e, _i),
                  _h = _s || _a3 ? null : this._clipToAllGeometries(e, [], this.geometries, r);

              if (_s || _a3 || o && null == _h) {
                var _i2 = this._cloneGeometries(this.geometries);

                for (var _s2 = 0; _s2 < _i2.length; _s2++) {
                  var _o2 = _i2[_s2];

                  if (t.within(e, _o2)) {
                    var _i3;

                    t.equals(e, _o2) || _o2.addRing(e.rings[0]);

                    var _r3 = _.getPolygonParts(this._simplify(_o2));

                    return _r3.length > 0 && (_i2[_s2] = _r3[0], _r3.length > 1 && (_i3 = _i2).push.apply(_i3, _toConsumableArray(_r3.slice(1)))), null == _i2[_s2] ? (this.pushToasterMessage(this.messages.errorCreatingHole), {}) : (_l ? this._updateGeometries([].concat(_toConsumableArray(_i2), _toConsumableArray(_.getPolygonParts(e)))) : this._updateGeometries(_i2), this._resetGraphics(), _l ? {
                      focusOnly: !0,
                      polygon: e
                    } : {});
                  }
                }

                var _o = [];

                for (var _s3 = 0; _s3 < _i2.length; _s3++) {
                  var _r4 = _i2[_s3];
                  t.intersects(e, _r4) && (_l && _o.push(t.intersect(e, _r4)), _i2[_s3] = t.difference(_r4, e));
                }

                _i2 = _i2.filter(function (e) {
                  return e;
                });

                var _r2 = _.getAllPolygonParts(_i2);

                return this._updateGeometries(_r2), _o.length && (!_s && _a3 && _n && _o.push(this._clipToAllGeometries(e, _o)), _o = _.getAllPolygonParts(_o), this._updateGeometries([].concat(_toConsumableArray(_r2), _toConsumableArray(_o)))), this._resetGraphics(), _o.length ? {
                  focusOnly: !0,
                  polygon: _o.slice(-1)[0]
                } : {};
              }

              return {
                polygon: _h
              };
            }

          case C:
            {
              var _t3 = this.geometries.filter(function (e) {
                return !_this5._areEqual(e, s);
              });

              return {
                polygon: this._clipToAllGeometries(e, [], _t3)
              };
            }

          default:
            return {};
        }
      } catch (a) {
        return this.handleError(a), {};
      }
    }
  }, {
    key: "_clipToAllGeometries",
    value: function _clipToAllGeometries(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.geometries;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      var r = e.extent.expand(1.1),
          a = [],
          addClipCandidate = function addClipCandidate(e) {
        if (null == e) return;
        var i = t.intersect(r, e);
        null != i && a.push(i);
      };

      i.forEach(addClipCandidate), s.forEach(addClipCandidate), o || (addClipCandidate(this.customerClipBoundary), addClipCandidate(this.otherImportsClipBoundary));

      var n = a.length > 0 ? t.intersect(r, t.union(a)) : null,
          l = _.getClippingBoundaries(s, this.mapView.spatialReference),
          h = t.union([n, l].filter(function (e) {
        return null != e;
      }));

      if (null == h) return e;
      var d = t.difference(e, h);
      if (null == d && (null != n ? d = t.difference(e, n) : s && s.length > 0 && null != l && t.intersect(e, l) && !t.intersect(e, t.union(s)) && (d = e), null == d)) throw new Error(JSON.stringify(this.messages.polygonWithinWarning));

      var c = _.getPolygonParts(d).filter(function (e) {
        return g.calculateArea(e) > .01;
      });

      return c.length > 0 ? t.union(c) : null;
    }
  }, {
    key: "_cloneGeometries",
    value: function _cloneGeometries(e) {
      return e.map(function (e) {
        return new s(e.toJSON());
      });
    }
  }, {
    key: "_createEditToolbarListeners",
    value: function _createEditToolbarListeners() {
      var _this6 = this;

      this.toolbarListeners.add(this.editToolbar.on("update", function (e) {
        var t = e.toolEventInfo,
            i = t && ["move-start", "reshape-start", "rotate-start", "scale-start", "vertex-add"].includes(t.type),
            s = t && ["move-stop", "reshape-stop", "rotate-stop", "scale-stop"].includes(t.type);

        if (i) {
          if (t && "move-start" === t.type && _this6.activeTool !== d.DrawNudge) return void _this6._toggleTool(e.graphics[0]);
          _this6.isEditing = !0, _this6._onEditStarted(e, "reshape-start" === t.type, "vertex-add" === t.type);
        } else if (s && _this6.isEditing) {
          _this6._onEditFinished(e) && _this6._unSelectTools();
        } else t && "move" === t.type ? _this6._onMoveGraphic(e) : t && "reshape" === t.type ? _this6._onMoveVertex(e) : t && "vertex-remove" === t.type && _this6._onRemoveVertex(e);
      }));
    }
  }, {
    key: "_createMapListeners",
    value: function _createMapListeners() {
      var _this7 = this;

      this._removeMapListeners(), this.mapListeners.add(this.mapView.on("double-click", function (e) {
        _this7.selectedGeometry && e.stopPropagation();
      })), this.mapListeners.add(this.mapView.on("pointer-move", function (e) {
        if ("active" === _this7.editToolbar.state && _this7.selectedGeometry && !_this7._mouseIsDown) {
          var _t4 = {
            include: [_this7.layer]
          };

          _this7.mapView.hitTest(e, _t4).then(function (t) {
            if (t.results.length) {
              var _t5 = _this7.selectedGeometry.rings.reduce(function (e, t) {
                return t.forEach(function (t) {
                  var s = new i({
                    x: t[0],
                    y: t[1],
                    spatialReference: _this7.mapView.spatialReference
                  });
                  e.push(_this7.mapView.toScreen(s));
                }), e;
              }, []),
                  _s4 = [];

              for (var _e2 = 0; _e2 < _t5.length - 1; _e2++) {
                _s4.push(_this7._getMidPoint(_t5[_e2], _t5[_e2 + 1]));
              }

              _t5.push.apply(_t5, _s4), _this7._mouseIsOver = _t5.some(function (t) {
                return g.arePointsWithinTolerance(e, t, 3);
              });
            }
          });
        }
      })), this.mapListeners.add(this.mapView.on("pointer-down", function (e) {
        e.button || (_this7._mouseIsDown = !0, _this7._mouseDownPnt = e);
      })), this.mapListeners.add(this.mapView.on("pointer-up", function (e) {
        if (_this7._mouseIsDown) if (_this7._mouseIsDown = !1, g.arePointsWithinTolerance(_this7._mouseDownPnt, e)) {
          var _t6 = _this7.geometries.find(function (t) {
            return t.contains(_this7.mapView.toMap(e));
          });

          if (_this7.activeTool === d.DrawUnion) {
            if (null != _t6) _this7._unionGeometries(_this7.selectedGeometry, _t6);else {
              var _t7 = _.getAllHolesAsPolygons(_this7.geometries).find(function (t) {
                return t.contains(_this7.mapView.toMap(e));
              });

              null != _t7 && _this7._unionGeometries(_this7.selectedGeometry, _t7);
            }
          } else _this7.activeTool !== d.DrawNudge && _this7._areEqual(_t6, _this7.selectedGeometry) ? _this7._mouseIsOver ? e.stopPropagation() : (_this7._mouseIsOver = !1, _this7._toggleTool(_this7._findGraphic(_this7.selectedGeometry))) : _this7._activateEditsForGeometry(_t6);
        } else _this7.isEditing || _this7.forceUpdate();
      }));
    }
  }, {
    key: "_createWindowListeners",
    value: function _createWindowListeners() {
      var _this8 = this;

      this.windowListeners.removeAll(), this.keyEvent = null;

      var addListener = function addListener(e, t) {
        return document.addEventListener(e, t), {
          remove: function remove() {
            return document.removeEventListener(e, t);
          }
        };
      };

      this.windowListeners.add(addListener("keydown", function (e) {
        _this8.keyEvent = e;
      })), this.windowListeners.add(addListener("keyup", function () {
        _this8.keyEvent = null;
      }));
    }
  }, {
    key: "_findGeometryIndex",
    value: function _findGeometryIndex(e) {
      var _this9 = this;

      return this.geometries.findIndex(function (t) {
        return _this9._areEqual(t, e);
      });
    }
  }, {
    key: "_findGraphic",
    value: function _findGraphic(e) {
      var _this10 = this;

      return this.layer.graphics.find(function (t) {
        return _this10._areEqual(t.geometry, e);
      });
    }
  }, {
    key: "_getCustomerFieldBoundary",
    value: function _getCustomerFieldBoundary(e, t, i) {
      var _this11 = this;

      return null == e ? (this._setCustomerClipBoundaries(null), Promise.resolve(null)) : (this.onSetCanClipPending(!0), w.getCustomerFieldBoundaries(e, t, i).then(function (e) {
        return _this11._setCustomerClipBoundaries(e), _this11.onSetCanClip(_this11._canClip()), _this11.onSetCanClipPending(!1), _this11.customerClipBoundary;
      }));
    }
  }, {
    key: "_setCustomerClipBoundaries",
    value: function _setCustomerClipBoundaries(e) {
      var _this12 = this;

      if (null == e) return this._overlapManager.reset(!0), void (this.customerClipBoundary = null);

      this._overlapManager.setCustomerBoundaries(e);

      var t = e.map(function (e) {
        return _this12._simplify(e.shape);
      }).filter(function (e) {
        return e;
      });
      this.customerClipBoundary = _.getClippingBoundaries(t, new r({
        wkid: L
      }));
    }
  }, {
    key: "_getMidPoint",
    value: function _getMidPoint(e, t) {
      return {
        x: (t.x - e.x) / 2 + e.x,
        y: (t.y - e.y) / 2 + e.y
      };
    }
  }, {
    key: "_getOtherImportFieldBoundaries",
    value: function _getOtherImportFieldBoundaries() {
      var _this13 = this;

      this.otherImportsClipBoundary = null;
      var e = [];
      if (null == this.importFieldList || 0 === this.importFieldList.length || null == this.importFieldBoundaryGuidList) return Promise.resolve(null);

      var _iterator3 = _createForOfIteratorHelper(this.importFieldList),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _t8 = _step3.value;
          this.customerGuid === _t8.customerGuid && e.push.apply(e, _toConsumableArray(_t8.importFieldBoundaryGuidList.filter(function (e) {
            return !_this13.importFieldBoundaryGuidList.includes(e);
          })));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return 0 === e.length ? Promise.resolve(null) : this.fieldBoundaryImportLayer.getImportFieldBoundaries(e).then(function (e) {
        return _this13.otherImportsClipBoundary = _.getClippingBoundaries(e.map(function (e) {
          return _this13._simplify(e.shape);
        }).filter(function (e) {
          return e;
        }), new r({
          wkid: L
        })), _this13.otherImportsClipBoundary;
      });
    }
  }, {
    key: "_isValid",
    value: function _isValid(e) {
      return _.isValidPolygon(e) && !_.isMultiPolygon(e);
    }
  }, {
    key: "_moveGeometryToTop",
    value: function _moveGeometryToTop(t) {
      var i = this._findGraphic(t);

      if (i) {
        this.layer.remove(i);

        var _t9 = e.fromJSON(i.toJSON());

        return this.layer.add(_t9), _t9;
      }
    }
  }, {
    key: "_onDraw",
    value: function _onDraw(e, t) {
      var _this14 = this;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var o = t.finished,
          r = t.geometry,
          a = t.points;

      switch (e) {
        case h.CIRCLE:
          this._updateRadius(o ? null : r);

        case h.POLYGON:
          if (this._updateAcreageLabel(r), o && !l()) {
            this.labelManager.clearLabel(), this.measureLabelManager.clearLabel();

            var _this$_clipPolygon = this._clipPolygon(r, P, null, !1, !s),
                _o3 = _this$_clipPolygon.focusOnly,
                _n2 = _this$_clipPolygon.polygon;

            if (!_o3 && i && this._overlapManager.checkGeometriesForOverlap([r])) return this._overlapManager.newPolygonEvent = {
              geometryType: e,
              event: t
            }, this.onOverlapDetected();
            _n2 ? _o3 ? this.reset().then(function () {
              _this14._unSelectTools(), _this14._activateEditsForGeometry(_n2);
            }) : this.addPolygon(_n2).then(function (t) {
              return _this14.reset().then(function () {
                _this14.lastDrawnPolygonPoints = e === h.POLYGON ? a : null, _this14._unSelectTools(), _this14._activateEditsForGeometry(t);
              });
            }) : this.reset().then(function () {
              return _this14._unSelectTools();
            });
          }

          break;

        case h.POLYLINE:
          if (o) {
            this.options.onSetMapIsLoading(!0);
            (this.activeTool === d.DrawReshapeLine ? _.reshapeGeometries : _.splitGeometries)(this.geometries, r).then(function (e) {
              try {
                if (_this14.activeTool === d.DrawReshapeLine) {
                  var _t10 = [];
                  e.forEach(function (e) {
                    _t10.push.apply(_t10, _toConsumableArray(_.getPolygonParts(_.clipGeometry(e, _this14.customerClipBoundary))));
                  }), e = _t10;
                }

                _this14._updateGeometries(e);
              } catch (t) {
                _this14.handleError(t);
              }
            }).catch(function (e) {
              console.error(e), _this14.pushToasterMessage(_this14.messages.errorModifyingGeometry);
            }).finally(function () {
              _this14.reset().then(function () {
                _this14._unSelectTools(), _this14._resetGraphics(), l() || _this14.options.onSetMapIsLoading(!1);
              });
            });
          }

      }

      this.forceUpdate();
    }
  }, {
    key: "_onEditStarted",
    value: function _onEditStarted(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var o = e.graphics[0];

      if (i && (this._addingVertex = !0), t) {
        var _t11 = e.toolEventInfo.selected,
            _t11$0$attributes = _t11[0].attributes,
            _s5 = _t11$0$attributes.pathIndex,
            _r5 = _t11$0$attributes.pointIndex,
            _a4 = null != this._ignore && g.areEqual(this._ignore.graphic.geometry, o.geometry) && this._ignore.vertexInfo.pathIndex === _s5 && this._ignore.vertexInfo.pointIndex === _r5,
            _n3 = g.getClusteredPoints(o.geometry, {
          isVertexAdd: i,
          pointIndex: _r5,
          pathIndex: _s5
        });

        if (_n3.length > 0 && !_a4) return this._preSimplifyPrompt = {
          graphic: o,
          vertexInfo: {
            pathIndex: _s5,
            pointIndex: _r5,
            isVertexAdd: this._addingVertex
          }
        }, this._activateEditsForGeometry(o.geometry), void this.options.onPrompt(c.SIMPLIFY_VERTEX_PROMPT, {
          count: _n3.length
        });
      }

      this._editGeometry = new s(o.geometry.toJSON()), this._editGeometryIndex = this._findGeometryIndex(this._editGeometry);
    }
  }, {
    key: "_onEditFinished",
    value: function _onEditFinished(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var o = e.graphics[0].geometry;

      if (this._addingVertex = !1, this.isEditing = !1, this._editGeometry) {
        var _r6 = this._editGeometryIndex;
        if (_r6 < 0 && (_r6 = this._findGeometryIndex(this.selectedGeometry)), _r6 >= 0) if (_.isValidPolygon(o)) {
          if (t && this._overlapManager.checkGeometriesForOverlap([o])) return this._overlapManager.editGeometryEvent = e, this.onOverlapDetected(), !1;

          var _a5 = this._cloneGeometries(this.geometries);

          if (_a5[_r6] = i ? this._clipPolygon(new s(o.toJSON()), C, this._editGeometry).polygon : o, _a5[_r6]) {
            var _e3 = _.getPolygonParts(_a5[_r6]);

            _a5[_r6] = _e3[0], _a5.push.apply(_a5, _toConsumableArray(_e3.slice(1)));
          } else _a5[_r6] = new s(this._editGeometry.toJSON());

          this._updateGeometries(_a5), this._resetGraphics(), this._activateEditsForGeometry(_a5[_r6], !0);
        } else this.geometries[_r6] = this._editGeometry, this._resetGraphics(), this._activateEditsForGeometry(this.geometries[_r6], !0);
      }

      return !0;
    }
  }, {
    key: "clipToOtherFields",
    value: function clipToOtherFields() {
      var _this15 = this;

      this.layer.graphics.filter(function (e) {
        return e.attributes && e.attributes.clippedGeometry;
      }).forEach(function (e) {
        return _this15.layer.remove(e);
      }), this.history.add(this.history.getState(this.history.getIndex()), !0), this._overlapManager.clipToOtherFields(), this._overlapManager.hasPendingImportBoundaries() ? this.addGeometries(this._overlapManager.importBoundaries) : this._overlapManager.hasPendingNewPolygonEvent() ? this._onDraw(this._overlapManager.newPolygonEvent.geometryType, this._overlapManager.newPolygonEvent.event, !1, !0) : this._overlapManager.hasPendingEditGeometryEvent() && this._onEditFinished(this._overlapManager.editGeometryEvent, !1, !0);
    }
  }, {
    key: "clipOtherFields",
    value: function clipOtherFields() {
      var _this16 = this;

      this.layer.graphics.filter(function (e) {
        return e.attributes && e.attributes.clippedGeometry;
      }).forEach(function (e) {
        return _this16.layer.remove(e);
      }), this.history.add(this.history.getState(this.history.getIndex()), !0), this._overlapManager.clipOtherFields(), this.customerClipBoundary = this._overlapManager.getClippedCustomerBoundariesCombined(), this._overlapManager.hasPendingImportBoundaries() ? this.addGeometries(this._overlapManager.importBoundaries, !1, !1, !1) : this._overlapManager.hasPendingNewPolygonEvent() ? this._onDraw(this._overlapManager.newPolygonEvent.geometryType, this._overlapManager.newPolygonEvent.event, !1, !1) : this._overlapManager.hasPendingEditGeometryEvent() && this._onEditFinished(this._overlapManager.editGeometryEvent, !1, !1);
    }
  }, {
    key: "cancelOverlap",
    value: function cancelOverlap() {
      var _this17 = this;

      this.layer.graphics.filter(function (e) {
        return e.attributes && e.attributes.clippedGeometry;
      }).forEach(function (e) {
        return _this17.layer.remove(e);
      }), this.history.truncateFutureStates(), this._overlapManager.hasPendingNewPolygonEvent() && this.polygonCreator.history.undo(), this._overlapManager.hasPendingEditGeometryEvent() && (this._resetGraphics(), this._activateEditsForGeometry(this.selectedGeometry)), this._overlapManager.cancel();
    }
  }, {
    key: "_onMoveGraphic",
    value: function _onMoveGraphic(e) {
      var t = e.toolEventInfo.mover.geometry;
      this._updateAcreageLabel(t), this.nudgeLabelManager.moveLabel(t.extent.center);
    }
  }, {
    key: "_onMoveVertex",
    value: function _onMoveVertex(e) {
      var t = e.toolEventInfo.graphic.geometry;
      this._updateAcreageLabel(t), e.toolEventInfo.graphic.set("symbol", _.isValidPolygon(t) ? this.geometrySymbol : this.invalidSymbol);
    }
  }, {
    key: "_onRemoveVertex",
    value: function _onRemoveVertex(e) {
      var _e$toolEventInfo$vert = e.toolEventInfo.vertices[0],
          t = _e$toolEventInfo$vert.componentIndex,
          s = _e$toolEventInfo$vert.vertexIndex,
          o = _e$toolEventInfo$vert.coordinates,
          _o4 = _slicedToArray(o, 2),
          r = _o4[0],
          a = _o4[1],
          n = new i({
        x: r,
        y: a,
        spatialReference: this.mapView.spatialReference
      }),
          l = e.graphics[0],
          h = l.clone().geometry;

      if (this._editGeometry = h.insertPoint(t, s, n), 0 === s) {
        var _e4 = this._editGeometry.rings[t].length - 1;

        this._editGeometry.setPoint(t, _e4, n);
      }

      this._editGeometryIndex = this._findGeometryIndex(this._editGeometry);
      var d = e.graphics[0].geometry;
      this._updateAcreageLabel(l.geometry), l.set("symbol", _.isValidPolygon(d) ? this.geometrySymbol : this.invalidSymbol), this._onEditFinished(e), this._unSelectTools();
    }
  }, {
    key: "_toggleTool",
    value: function _toggleTool(e) {
      var _this18 = this;

      var t = "reshape" !== this.editToolbar.activeTool ? "reshape" : "transform";
      this.editToolbar.cancel(), this.editToolbar.update(e, {
        tool: t
      }).then(function () {
        _this18._updateAcreageLabel(e.geometry);
      });
    }
  }, {
    key: "_removeClusteredVertices",
    value: function _removeClusteredVertices() {
      this.editToolbar.cancel(), this._ignore = null;
      var _this$_preSimplifyPro = this._preSimplifyPrompt,
          e = _this$_preSimplifyPro.graphic,
          t = _this$_preSimplifyPro.vertexInfo;

      var i = this._findGeometryIndex(e.geometry);

      if (i < 0) return;

      var s = this._cloneGeometries(this.geometries);

      var o = s[i];
      var r = g.getClusteredPoints(o, t);

      var _iterator4 = _createForOfIteratorHelper(r),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _a6 = _step4.value;

          var _a7 = _slicedToArray(_a6, 2),
              _e5 = _a7[0],
              _t12 = _a7[1];

          o.rings[_e5].length <= 3 || o.removePoint(_e5, _t12);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      o = this._simplify(o), s[i] = o, this._updateGeometries(s), this._resetGraphics(), this._activateEditsForGeometry(o);
    }
  }, {
    key: "_removeMapListeners",
    value: function _removeMapListeners() {
      this._mouseIsDown = !1, this.mapListeners.removeAll();
    }
  }, {
    key: "_resetGraphics",
    value: function _resetGraphics() {
      var _this19 = this;

      this.layer.removeAll(), this.measureLayer.removeAll(), this.labelManager.clearLabel(), this.measureLabelManager.clearLabel(), this.nudgeLabelManager.clearLabel(), this.geometries.forEach(function (t) {
        _this19.layer.add(new e({
          geometry: t,
          symbol: _this19.geometrySymbol
        }));
      });
    }
  }, {
    key: "_simplify",
    value: function _simplify(e) {
      return t.isSimple(e) ? e : t.simplify(e);
    }
  }, {
    key: "_unionGeometries",
    value: function _unionGeometries(e, i) {
      console.assert(null != e && null != i), this.options;
      var s = [e, i],
          o = t.union(s);
      if (_.getTotalPolygonPartCount(s) === _.getTotalPolygonPartCount([o]) && _.getTotalPolygonHoleCount(s) === _.getTotalPolygonHoleCount([o])) return void this.pushToasterMessage(this.messages.errorUnableToUnion);

      var r = this._findGeometryIndex(e),
          a = this._findGeometryIndex(i),
          n = this.geometries.filter(function (e, t) {
        return ![r, a].includes(t);
      });

      n.push.apply(n, _toConsumableArray(_.getPolygonParts(o))), this._updateGeometries(n), this._unSelectTools(), this._resetGraphics(), this._activateEditsForGeometry(o, !0);
    }
  }, {
    key: "_unSelectTools",
    value: function _unSelectTools() {
      [this.drawPolygon, this.drawCircle, this.drawReshape, this.drawSplit, this.drawNudge, this.drawUnion].some(function (e) {
        return !!e && (e.unselect(!0), !0);
      }), this.menu && this.menu.toggleTool({
        selected: !1
      }), this.initActivation({
        tool: null,
        activate: !1
      }, this._activateTool), this._createMapListeners(), this.mapView.container.style.cursor = p.default, this.forceUpdate();
    }
  }, {
    key: "_updateGeometries",
    value: function _updateGeometries(e) {
      var _this20 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      this.lastDrawnPolygonPoints = null, this.geometries = e.map(this._simplify).filter(function (e) {
        return e && g.calculateArea(e) > .01;
      });

      var i = this._cloneGeometries(this.geometries);

      this.history.add(i, t), this.onUpdateGeometries(this.geometries), setTimeout(function () {
        _this20.onSetCanClip(_this20._canClip()), _this20.forceUpdate();
      });
    }
  }, {
    key: "_updateAcreageLabel",
    value: function _updateAcreageLabel(e) {
      e && e.rings[0].length > 3 ? this.labelManager.updateLabel(g.getPolyLabelPoint(e), this.getAcreageText(e)) : this.labelManager.clearLabel();
    }
  }, {
    key: "_updateRadius",
    value: function _updateRadius(t) {
      if (this.measureLayer.removeAll(), t && t.radius && t.center.x) {
        this.measureLayer.add(new e({
          geometry: g.createPolyline([t.center, new i({
            x: t.center.x,
            y: t.extent.ymin,
            spatialReference: t.spatialReference
          })]),
          symbol: this.radiusLineSymbol
        }));

        var _s6 = t.center.y - (t.center.y - t.extent.ymin) / 2;

        this.measureLabelManager.updateLabel(new i({
          x: t.center.x,
          y: _s6,
          spatialReference: t.spatialReference
        }), "".concat(this.options.formatNumber(t.radius, this.intlConfig.wholeNumberFormatOptions), " ft"));
      } else this.measureLabelManager.clearLabel();
    }
  }, {
    key: "_activateTool",
    value: function _activateTool(e) {
      switch (this.mapView.container.style.cursor = p.crosshair, this._createWindowListeners(), e) {
        case d.DrawPolygon:
          this.isUndoDrawPolygon && this.lastDrawnPolygonPoints ? (this.polygonCreator.activate(this.lastDrawnPolygonPoints.slice(0, -1)), this.isUndoDrawPolygon = !1) : this.polygonCreator.activate();
          break;

        case d.DrawCircle:
          this.circleCreator.activate();
          break;

        case d.DrawReshapeLine:
        case d.DrawSplitLine:
          this.polylineCreator.activate();
          break;

        case d.DrawNudge:
        case d.DrawUnion:
          this.mapView.container.style.cursor = p.default, this._createMapListeners(), this.selectedGeometry ? this._activateEditsForGeometry(this.selectedGeometry) : this.geometries.length > 0 && this._activateEditsForGeometry(this.geometries[0]);
          break;

        default:
          this.mapView.container.style.cursor = p.default;
      }
    }
  }, {
    key: "activateToolset",
    value: function activateToolset() {
      this._resetGraphics(), this.disabled ? this.reset() : this.activeTool ? this._activateTool(this.activeTool) : (this._createMapListeners(), this.selectedGeometry && this._activateEditsForGeometry(this.selectedGeometry));
    }
  }, {
    key: "addGeometries",
    value: function addGeometries(t) {
      var _this21 = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var r = [];
      i && (this.geometries = []);

      var _iterator5 = _createForOfIteratorHelper(t),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _e6 = _step5.value;

          var _this$_clipPolygon2 = this._clipPolygon(_e6, P, null, !0),
              _t13 = _this$_clipPolygon2.focusOnly,
              _i5 = _this$_clipPolygon2.polygon;

          if (_i5 && !_t13) {
            var _t14 = _.getPolygonParts(o ? _i5 : _e6).map(this._simplify).filter(function (e) {
              return e;
            });

            r.push.apply(r, _toConsumableArray(_t14));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (0 !== r.length) {
        if (s && this._overlapManager.checkGeometriesForOverlap(t)) {
          this._overlapManager.importBoundaries = t;

          var _i4 = t.map(function (t) {
            return new e({
              attributes: {
                clippedGeometry: !0
              },
              geometry: t,
              symbol: _this21.geometrySymbol
            });
          });

          return this.layer.addMany(_i4), this.onOverlapDetected();
        }

        this._updateGeometries([].concat(_toConsumableArray(this.geometries), r)), this._resetGraphics(), this.reset().then(function () {
          _this21._unSelectTools(), _this21._activateEditsForGeometry(r[0]), g.verifyIntersections(_this21.geometries) && _this21.setEditClip(), w.zoomToFeatures(_this21.mapView, _this21.geometries, v.defaults.extentExpandFactor);
        });
      }
    }
  }, {
    key: "addPolygon",
    value: function addPolygon(e) {
      var _this22 = this;

      return new Promise(function (t) {
        var i = _.getPolygonParts(e);

        _this22._updateGeometries([].concat(_toConsumableArray(_this22.geometries), _toConsumableArray(i))), _this22._resetGraphics(), t(i[0]);
      });
    }
  }, {
    key: "canDelete",
    value: function canDelete() {
      return !this.activeTool && Boolean(this.selectedGeometry);
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      switch (this.activeTool) {
        case d.DrawPolygon:
          return this.polygonCreator.history.canRedo() || this.history.canRedo();

        case d.DrawReshapeLine:
        case d.DrawSplitLine:
          return this.polylineCreator.history.canRedo() || this.history.canRedo();

        case d.DrawCircle:
        case d.DrawNudge:
        case d.DrawUnion:
          return !1;

        default:
          return this.history.canRedo();
      }
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      switch (this.activeTool) {
        case d.DrawPolygon:
          return this.polygonCreator.history.canUndo() || this.history.canUndo();

        case d.DrawReshapeLine:
        case d.DrawSplitLine:
          return this.polylineCreator.history.canUndo() || this.history.canUndo();

        case d.DrawCircle:
        case d.DrawNudge:
        case d.DrawUnion:
          return !1;

        default:
          return this.lastDrawnPolygonPoints && !this.history.canRedo() || this.history.canUndo();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this23 = this;

      return this.reset().then(function () {
        _this23._overlapManager.reset(!0), _this23._updateGeometries([], !0), _this23._resetGraphics();
      });
    }
  }, {
    key: "clipImportGeometries",
    value: function clipImportGeometries(e) {
      var _this24 = this;

      var t = this.geometries.map(function (e) {
        return e.clone();
      });
      this.geometries = e.map(function (e) {
        return _this24._simplify(e);
      }).filter(function (e) {
        return e && g.calculateArea(e) > .01;
      }), this.addGeometries(t, !1);
    }
  }, {
    key: "clip",
    value: function clip() {
      var _this25 = this;

      this._canClip() && (this.options.onSetMapIsLoading(!0), setTimeout(function () {
        var e = null,
            i = null;

        if (_this25.selectedGeometry && _this25.geometries.length > 1) {
          var _s7 = _this25.geometries.filter(function (e) {
            return !_this25._areEqual(e, _this25.selectedGeometry);
          });

          _s7.length > 0 && null != t.intersect(_this25.selectedGeometry, t.union(_s7)) && (i = _this25.geometries.map(function (t) {
            return _this25._areEqual(_this25.selectedGeometry, t) ? (e = _this25._clipPolygon(t, C, t).polygon, e) : t;
          }).filter(function (e) {
            return null != e;
          }));
        }

        null == i && (i = _this25.geometries.map(function (t) {
          var i = _this25._clipPolygon(t, C, t).polygon;

          return _this25.selectedGeometry && _this25._areEqual(_this25.selectedGeometry, t) && (e = i), i;
        }).filter(function (e) {
          return null != e;
        })), _this25._updateGeometries(_.getAllPolygonParts(i)), _this25._resetGraphics(), _this25._activateEditsForGeometry(i.length > 0 && null != e ? _.getAllPolygonParts([e])[0] : null), _this25.options.onSetMapIsLoading(!1), g.checkMinAcreage(_this25.geometries) && _this25.options.onPrompt(c.REMOVE_MIN_AREA_POLYS);
      }));
    }
  }, {
    key: "confirmSimplify",
    value: function confirmSimplify(e) {
      if (e) this._removeClusteredVertices();else if (null != this._preSimplifyPrompt) {
        var _this$_preSimplifyPro2 = this._preSimplifyPrompt,
            _e7 = _this$_preSimplifyPro2.graphic,
            _t15 = _this$_preSimplifyPro2.vertexInfo;
        this._ignore = {
          graphic: _e7,
          vertexInfo: _t15
        };
      }
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this26 = this;

      this.canDelete() && (this.removeGeometry(this.selectedGeometry), this.reset().then(function () {
        _this26._createMapListeners();
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this27 = this;

      this.mapListeners.removeAll(), this.toolbarListeners.removeAll(), this.windowListeners.removeAll(), this.editToolbar.destroy(), this.reset().then(function () {
        return Object.keys(_this27).forEach(function (e) {
          _this27[e] = null;
        });
      });
    }
  }, {
    key: "geometriesIntersect",
    value: function geometriesIntersect() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return 0 !== this.geometries.length && 0 !== e.length && t.intersects(t.union(this.geometries), t.union(e));
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return {
        top: 0,
        left: 210,
        leftAndRight: !0,
        width: 10 + 70 * (this.includeClipTool ? 7 : 6),
        height: 51
      };
    }
  }, {
    key: "getTools",
    value: function getTools() {
      return [d.DrawCircle, d.DrawPolygon, d.DrawNudge, d.DrawReshapeLine, d.DrawSplitLine, d.DrawUnion];
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this28 = this;

      if (!this.canRedo()) return;

      var redo = function redo() {
        return _this28.history.redo().then(function (e) {
          return _this28._applyHistoryState(e);
        });
      };

      switch (this.activeTool) {
        case d.DrawPolygon:
          this.polygonCreator.history.canRedo() ? this.polygonCreator.history.redo() : this.polygonCreator.deactivate().then(function () {
            _this28._unSelectTools(), redo();
          });
          break;

        case d.DrawReshapeLine:
        case d.DrawSplitLine:
          this.polylineCreator.history.canRedo() ? this.polylineCreator.history.redo() : this.polylineCreator.deactivate().then(function () {
            _this28._unSelectTools(), redo();
          });
          break;

        case d.DrawCircle:
        case d.DrawNudge:
        case d.DrawUnion:
          break;

        default:
          redo();
      }
    }
  }, {
    key: "removeGeometry",
    value: function removeGeometry(e) {
      var t = this._findGeometryIndex(e);

      if (t >= 0) {
        var _e8 = _toConsumableArray(this.geometries);

        _e8.splice(t, 1), this._updateGeometries(_e8), this._resetGraphics();
      }
    }
  }, {
    key: "removeMinAreaPolygons",
    value: function removeMinAreaPolygons() {
      var _this29 = this;

      this.geometries.filter(function (e) {
        return t.geodesicArea(e, "acres") < .25;
      }).forEach(function (e) {
        return _this29.removeGeometry(e);
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this30 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return new Promise(function (t) {
        if (_this30._removeMapListeners(), _this30.mapView.container.style.cursor = p.default, _this30.labelManager.clearLabel(), _this30.measureLabelManager.clearLabel(), _this30.nudgeLabelManager.clearLabel(), _this30.activeTool === d.DrawUnion && _this30._resetGraphics(), e) return void t();
        _this30.setActiveTool(null), _this30.selectedGeometry = null, _this30.editToolbar.cancel();
        var i = [];
        i.push(_this30.circleCreator.deactivate()), i.push(_this30.polygonCreator.deactivate()), i.push(_this30.polylineCreator.deactivate()), Promise.all(i).then(function () {
          t();
        });
      });
    }
  }, {
    key: "resetTools",
    value: function resetTools() {
      var _this31 = this;

      setTimeout(function () {
        return _this31._unSelectTools();
      });
    }
  }, {
    key: "setToolbarMenuInset",
    value: function setToolbarMenuInset(e) {
      var t = e ? [e] : [];
      return this.autoPan.setInsets(t), this.circleCreator.setInsets(t), this.polygonCreator.setInsets(t), this.polylineCreator.setInsets(t), t;
    }
  }, {
    key: "toggleTool",
    value: function toggleTool(e) {
      var _this32 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = this.selectedGeometry;
      this.reset(e.isRenderRequest).then(function () {
        if (e.selected) {
          var _s8;

          switch (e.index) {
            case 0:
              _s8 = d.DrawPolygon;
              break;

            case 1:
              _s8 = d.DrawCircle;
              break;

            case 2:
              _s8 = d.DrawReshapeLine;
              break;

            case 3:
              _s8 = d.DrawSplitLine;
              break;

            case 4:
              _s8 = d.DrawNudge, _this32.selectedGeometry = i;
              break;

            case 5:
              _s8 = d.DrawUnion, _this32.selectedGeometry = i;
              break;

            default:
              _s8 = null;
          }

          _this32.initActivation({
            tool: _s8,
            activate: !0,
            byPassShare: !1,
            forceUpdate: t
          }, _this32._activateTool), _this32._bubbleOpLayers();
        } else _this32.initActivation({
          tool: null,
          activate: !1
        }, _this32._activateTool), _this32._createMapListeners(), _this32.mapView.container.style.cursor = p.default;

        t && _this32.forceUpdate();
      });
    }
  }, {
    key: "setLayers",
    value: function setLayers(_ref4) {
      var e = _ref4.fieldsLayer,
          t = _ref4.fieldBoundaryImportLayer;
      _get(_getPrototypeOf(DrawTools.prototype), "setLayers", this).call(this, {
        fieldsLayer: e,
        fieldBoundaryImportLayer: t
      }), this._overlapManager.fieldsLayer = e;
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this33 = this;

      if (!this.canUndo()) return;

      var undo = function undo() {
        return _this33.history.undo().then(function (e) {
          return _this33._applyHistoryState(e);
        });
      };

      switch (this.activeTool) {
        case d.DrawPolygon:
          this.polygonCreator.history.canUndo() ? this.polygonCreator.history.undo() : this.polygonCreator.deactivate().then(function () {
            _this33._unSelectTools();
          });
          break;

        case d.DrawReshapeLine:
        case d.DrawSplitLine:
          this.polylineCreator.history.canUndo() ? this.polylineCreator.history.undo() : this.polylineCreator.deactivate().then(function () {
            _this33._unSelectTools();
          });
          break;

        case d.DrawCircle:
        case d.DrawNudge:
        case d.DrawUnion:
          break;

        default:
          !this.lastDrawnPolygonPoints || this.history.canRedo() || this._overlapManager.canUndo() && 1 === this.history.historyIndex ? undo() : (undo(), this.isUndoDrawPolygon = !0, this.drawPolygon.toggle(!0));
      }
    }
  }, {
    key: "updateCustomerGuid",
    value: function updateCustomerGuid(_ref5) {
      var _this34 = this;

      var e = _ref5.customerGuid,
          t = _ref5.fieldGuid;
      if (this.customerGuid === e) return;
      this.customerGuid = e, this.options.onSetToolsProcessing(!0);
      var i = [];
      i.push(this._getCustomerFieldBoundary(e, t)), i.push(this._getOtherImportFieldBoundaries()), Promise.all(i).then(function () {
        _this34.options.onSetToolsProcessing(!1);
      }), this._bubbleOpLayers();
    }
  }, {
    key: "updateImportFieldList",
    value: function updateImportFieldList(e) {
      var _this35 = this;

      this.importFieldList = e, this.isImport ? (this.options.onSetToolsProcessing(!0), this._getOtherImportFieldBoundaries().then(function () {
        _this35.options.onSetToolsProcessing(!1);
      }), this._bubbleOpLayers()) : this.otherImportsClipBoundary = null;
    }
  }]);

  return DrawTools;
}(a);

export { DrawTools as D };